export const GET_ARTICLE_REQUEST    = 'MAG/GET_ARTICLE_REQUEST';
export const GET_ARTICLE_SUCCESS    = 'MAG/GET_ARTICLE_SUCCESS';
export const GET_ARTICLE_FAILED     = 'MAG/GET_ARTICLE_FAILED';

export const GET_ARTICLES_REQUEST   = 'MAG/GET_ARTICLES_REQUEST';
export const GET_ARTICLES_SUCCESS   = 'MAG/GET_ARTICLES_SUCCESS';
export const GET_ARTICLES_FAILED    = 'MAG/GET_ARTICLES_FAILED';
